export default __webpack_public_path__ + "static/media/tk.ed62c42c.jpg";